import { routes_api } from "../config/api";
import { api_url, default_api_token, screenToken, tokenId } from "../config/constant";
import { getItem } from "../utils/storage";
import { Methods, makeRequest } from "./request";

export const init_screen = (preview_data, isDemo) => {
  const id = isDemo ? 'demo' : (preview_data?.preview_flow ?? getItem(screenToken))
  const url = api_url + (preview_data?.preview_flow ? routes_api.screen.init_preview : routes_api.screen.init) + id;

  return makeRequest(url, Methods.POST, null, { 'Authorization': default_api_token });
}

export const log_mercure = (type, subscribeTopics) => {
  const token = getItem(screenToken)
  const id = getItem(tokenId)

  if (!token) {
    return null;
  }

  let url = api_url + routes_api.screen.mercure_log
  url = url.replace(':screen_token', token)
  url = url.replace(':screen_id', id)

  return makeRequest(url, Methods.POST, { type, ...subscribeTopics }, { 'Authorization': default_api_token });
}

export const pingScreen = () => {
  const token = getItem(screenToken)
  const id = getItem(tokenId)

  if (!token) {
    return null;
  }

  let url = api_url + routes_api.screen.ping_screen
  url = url.replace(':screen_token', token)
  url = url.replace(':screen_id', id)

  const data = {}

  try {
    data.screenConfig = {
      'width': window?.screen?.width,
      'height': window?.screen?.height,
      'orientation': window?.screen?.orientation?.type,
    }
  } catch (event) { 
    console.error(event)
  }

  try {
    data.userAgent = navigator?.userAgent
  } catch (event) { 
    console.error(event)
  }

  try {
    data.screenConfig.performance = {
      'jsHeapSizeLimit': performance?.memory?.jsHeapSizeLimit,
      'totalJSHeapSize': performance?.memory?.totalJSHeapSize,
      'usedJSHeapSize': performance?.memory?.usedJSHeapSize,
    }
  } catch (event) {
    console.error(event)
  }

  return makeRequest(url, Methods.POST, data, { 'Authorization': default_api_token });
}

export const init_flow = (flow_id, preview_data) => {
  const id = preview_data?.preview_flow ? `${flow_id}_${preview_data.user_id}_${preview_data.token}` : getItem(screenToken)
  const params = preview_data?.preview_flow ? `${routes_api.screen.init_preview}:token` : routes_api.screen.init_flow
  let url = api_url + params
  url = url.replace(':token', id)
  url = url.replace(':flow_id', flow_id)

  return makeRequest(url, Methods.POST, null, { 'Authorization': default_api_token });
}

export const init_area = (flow_id, area_id) => {
  const id = getItem(screenToken)
  let url = api_url + routes_api.screen.init_area
  url = url.replace(':token', id)
  url = url.replace(':flow_id', flow_id)
  url = url.replace(':area_slug', area_id)

  return makeRequest(url, Methods.POST, null, { 'Authorization': default_api_token });
}

export const get_loading_screen = (url) => {
  return makeRequest(url, Methods.GET, null, { 'Authorization': default_api_token });
}

export const sendScreenshot = (image, id) => {
  let url = api_url + routes_api.screen.screenshot
  url = url.replace(':id', id)

  return makeRequest(url, Methods.POST, { file: image }, { 'Authorization': default_api_token });
}

